import remoteConfigService from '../../services/remoteConfigService'

class RemoteConfigController {
  fetchRemoteConfig = remoteConfigService.fetchRemoteConfig
}

export default new RemoteConfigController()
 


// WEBPACK FOOTER //
// ../src/controllers/remoteConfigController/remoteConfigController.js